import { render, staticRenderFns } from "./SetPriceDialog.vue?vue&type=template&id=49e8b2a2"
import script from "./SetPriceDialog.vue?vue&type=script&lang=js"
export * from "./SetPriceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports